


import App from '../App'
import { connect } from 'react-redux'
import {
  updateFilters,
  updateTab,
  updateSearchDirection,
  updatePage,
  getBrokerShipmentList,
  setDocumentTypes
} from '../actions/searchContextActions'

const mapStateToProps = state => ({
  ...state.searchContext
});

const mapDispatchToProps = {
  setDocumentTypes,
  updateFilters,
  updateTab,
  updateSearchDirection,
  getBrokerShipmentList,
  updatePage
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
